export const MyCommunityCardsSkeleton = () => {

    return (
        <div className="w-full lg:rounded-small rounded-micro overflow-hidden flex flex-col lg:gap-3 gap-2 h-20 bg-grey-100 animate-pulse" />
    )
}
